import { setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import config from '@/config'
import { decryptByDes } from '@/utils/utils'
const user = {
  state: {
    userInfo: '',
    roles: [],
    defaultPwd: ''
  },

  mutations: {
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_DEFAULT_PWD: (state, pwd) => {
      state.defaultPwd = pwd
    }
  },

  actions: {
    setUserInfo({ commit }, userInfo) {
      return new Promise(resolve => {
        commit('SET_USER_INFO', userInfo)
        resolve()
      })
    },
    getUserInfo({ state, commit }) {
      return new Promise(resolve => {
        if (!state.userInfo) {
          const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          commit('SET_USER_INFO', userInfo)
          commit('SET_ROLES', [userInfo.role])
        } else {
          commit('SET_ROLES', [state.userInfo.role])
        }
        resolve(state.userInfo)
      })
    },
    resetToken({ commit }) {
      return new Promise(resolve => {
        commit('SET_USER_INFO', '')
        commit('SET_ROLES', [])
        removeToken()
        resolve()
      })
    },
    logout({ commit }) {
      removeToken()
      commit('SET_USER_INFO', {})
      commit('SET_ROLES', [])
      localStorage.removeItem('userInfo')
      resetRouter()
    },
    setDefaultPwd({ commit }, pwd) {
      return new Promise(resolve => {
        pwd = decryptByDes(pwd, config.DEFAULTPWD.key, config.DEFAULTPWD.iv)
        commit('SET_DEFAULT_PWD', pwd)
        resolve(pwd)
      })
    }
  },
  namespaced: true
}

export default user
